import type { TFunction } from 'i18next';

const DEFAULT_NAME_PATTERNS: { type: string; regex: RegExp }[] = [
  { type: 'Zone', regex: /^Zone\s+(\d+)$/i },
  { type: 'Aisle', regex: /^Aisle\s+(\d+)$/i },
  { type: 'Platform', regex: /^Platform\s+(\d+)$/i },
  { type: 'Rack', regex: /^Rack\s+(\d+)$/i },
  { type: 'Level', regex: /^Level\s+(\d+)$/i },
  { type: 'Bin', regex: /^Bin\s+(\d+)$/i },
];

const TR_TYPE_LABELS: Record<string, string> = {
  Zone: 'Bölge',
  Aisle: 'Koridor',
  Platform: 'Peron',
  Rack: 'Raf',
  Level: 'Kat',
  Bin: 'Bölme',
};

export function getLocationTypeLabel(type: string, t: TFunction): string {
  return t(`lookup.locationType.${type}`, { defaultValue: TR_TYPE_LABELS[type] || type });
}

/** İngilizce varsayılan lokasyon adlarını (Zone 1, Rack 01 vb.) görüntü için Türkçeleştirir. */
export function formatLocationDisplayName(name: string, type: string, t: TFunction): string {
  if (!name?.trim()) return name;

  for (const { type: locType, regex } of DEFAULT_NAME_PATTERNS) {
    if (type && locType !== type) continue;
    const match = name.match(regex);
    if (match) {
      const label = getLocationTypeLabel(locType, t);
      return `${label} ${match[1]}`;
    }
  }

  return name;
}

export function buildDefaultLocationName(type: string, index: number, t?: TFunction): string {
  const label = t ? getLocationTypeLabel(type, t) : (TR_TYPE_LABELS[type] || type);
  const num = type === 'Rack' ? String(index).padStart(2, '0') : String(index);
  return `${label} ${num}`;
}
